import React, {Component, PropTypes} from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';

import validators from './validators/index';
import {ValidatonError} from '../resources/GenericResource';

import CurrentUserActions from '../actions/CurrentUserActions';


const LoginFormModel = t.struct({
    email: validators.email,
    password: t.Str
});

function formLayout(locals){
    let renderedInputs = Object.keys(locals.inputs).map(function(key){
        return fieldLayout(locals.inputs[key]);
    });
    return (
        <div>
            {renderedInputs}
        </div>
    );
}

function fieldLayout(field){
    return (
        <label className="form-control form-control-text">
            {field}
        </label>
    );
}

const Form = baseFormFactory(LoginFormModel, true, true);

class LoginForm extends Form {
    constructor(props) {
        super(props);

        let isValid = false;

        this.state = {
            isValid: isValid,
            value: props.originalFormData,
        }
    }

    reSendActivationEmail() {
        CurrentUserActions.sendActivationEmail(this.props.activationEmail);
    }

    getValue() {
        return this.refs.form.getValue();
    }

    getOptions() {
        const loginError = this.props.loginError;
        return {
            auto: 'placeholders',
            hasError: !!loginError,
            template: formLayout,
            fields: {
                email: {
                    hasError: !!loginError,
                    error: loginError && loginError['email'] ? 'Please enter a valid email.' : null
                },

                password: {
                    type: 'password',
                    hasError: !!loginError,
                    error: (
                        loginError && loginError['password'] ?
                            'Please enter a password.' : null) || loginError.error ?
                                loginError.error.nonFieldErrors.startsWith('Your account') ?
                                    <span>Your account hasn't been activated. Re send activation <a href="#" onClick={this.reSendActivationEmail.bind(this)}>email</a>.</span> :
                                    'Unable to log in with provided credentials.' :
                                    null
                }
            }
        };
    }

    render() {
        return (
            <t.form.Form ref="form" value={this.state.value} type={LoginFormModel} options={this.getOptions()} onChange={this.onChange.bind(this)} />
        );
    }
}

LoginForm.propTypes = {
    originalFormData: React.PropTypes.object.isRequired
};

export default LoginForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/LoginForm.js
 **/